<!-- SAVING -->
<app-text-divider>SAVE SETTINGS</app-text-divider>
<div class="horizontal-container">
  <button
    class="form-item-button"
    style="margin: 5px 5px 0px 0px"
    mat-mini-fab
    (click)="savePathfinderConfig()"
    [disabled]="disableSaveConfig()"
    color="primary"
    matTooltip="Save your current settings"
    aria-label="Save your current settings"
    >
    <mat-icon>save</mat-icon>
  </button>
</div>
<!-- PORTAL SETTINGS -->
<app-text-divider>GENERAL SETTINGS</app-text-divider>
<div class="horizontal-container">
  <mat-form-field>
    <mat-label>Allowed Portals</mat-label>
    <mat-select [(ngModel)]="userSettingsService.getUserPathfinderConfig().portalKinds" (ngModelChange)="settingsChanged()" multiple>
      @for (portal of portalKinds; track portal) {
        <mat-option [value]="portal">{{ portal }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
  <mat-form-field>
    <mat-label>Maps to Avoid</mat-label>
    <mat-select [(ngModel)]="userSettingsService.getUserPathfinderConfig().mapsToAvoid" (ngModelChange)="settingsChanged()" multiple>
      <mat-option>
        <ngx-mat-select-search
          ngModel
          (ngModelChange)="filterClustersNames($event)"
          placeholderLabel="Search"
          noEntriesFoundLabel="No matches"
        ></ngx-mat-select-search>
      </mat-option>
      @for (cluster of filteredMapsNames; track $index) {
        <mat-option [value]="cluster">{{ cluster }}</mat-option>
      }
      <mat-select-trigger>
        <div class="trigger-container">
          @if (userSettingsService.getUserPathfinderConfig().mapsToAvoid.length > 0) {
            Clear Selected
            <button
              mat-icon-button
              class="clear-button"
              (click)="userSettingsService.getUserPathfinderConfig().mapsToAvoid = []"
              aria-label="Clear Selected Gategory"
              >
              <mat-icon>close</mat-icon>
            </button>
          }
        </div>
      </mat-select-trigger>
    </mat-select>
  </mat-form-field>

  <mat-form-field>
    <mat-label>Speed (m/s)</mat-label>
    <input matInput type="number" [(ngModel)]="userSettingsService.getUserPathfinderConfig().speed" min="1" max="20" step="0.1" />
  </mat-form-field>
</div>
<div class="horizontal-container">
  <p>Selected maps to avoid:</p>
  <ul>
    @for (map of userSettingsService.getUserPathfinderConfig().mapsToAvoid; track map) {
      <li>
        {{ map }}
      </li>
    }
  </ul>
</div>
<!-- PVP SETTINGS -->
<app-text-divider>PVP MAPS WEIGHTS (1-10)</app-text-divider>
<div class="horizontal-container">
  @for (pvpCategory of pvpCategories; track pvpCategory) {
    <mat-form-field>
      <mat-label> {{ pvpCategory | titlecase }} </mat-label>
      <input
        matInput
        type="number"
        [(ngModel)]="userSettingsService.getUserPathfinderConfig().pvpCategoryWeights[pvpCategory]"
        (ngModelChange)="settingsChanged()"
        min="1"
        max="20"
        step="0.1"
        />
      </mat-form-field>
    }
  </div>
  <!-- MAP CATEGORY SETTINGS -->
  <app-text-divider>MAP CATEGORY WEIGHTS (1-10)</app-text-divider>
  <div class="horizontal-container">
    @for (mapCategory of mapCategories; track mapCategory) {
      <mat-form-field>
        <mat-label> {{ mapCategory | titlecase }} </mat-label>
        <input
          matInput
          type="number"
          [(ngModel)]="userSettingsService.getUserPathfinderConfig().mapCategoryWeights[mapCategory]"
          (ngModelChange)="settingsChanged()"
          min="1"
          max="20"
          step="0.1"
          />
        </mat-form-field>
      }
    </div>
